import { useMemo } from 'react';
import { Box } from '@mui/material';
import PayeeSelector from '@shared/components/PayeeSelector';
import moment from 'moment';

const BookingPayeeSection = ({
  payee,
  formik,
  isaBuying,
  cancelationFee,
  search,
}) => {
  const deadline = useMemo(() => {
    if (!cancelationFee?.DeadLineCancel || !search?.checkIn) return null;
    return moment(search.checkIn).subtract(
      Number(cancelationFee.DeadLineCancel),
      'days'
    );
  }, [cancelationFee, search]);

  const fechaCancel = deadline?.format('DD/MM/YYYY');

  const day = cancelationFee?.if_cancel_by_provider
    ? fechaCancel
    : moment().add(1, 'days').format('DD/MM/YYYY');

  // Mensaje dinámico para pointOfSale
  let pointOfSaleMessage;
  if (isaBuying) {
    pointOfSaleMessage = (
      <>
        Para cualquier consulta, comunicarse con la sucursal {payee.name}{' '}
        seleccionada
      </>
    );
  } else {
    pointOfSaleMessage = (
      <>
        Deberá acercarse a la sucursal de {payee.name} seleccionada para
        finalizar el proceso de compra, que incluye el pago, la emisión y la
        entrega del voucher. En caso de no confirmar el pago, tenga en cuenta
        que la reserva se cancelará automáticamente a{' '}
        <Box component="span" sx={{ fontWeight: 600 }}>
          las 22 hs del día {day}
        </Box>
      </>
    );
  }

  return (
    <PayeeSelector
      payee={payee}
      formik={formik}
      pointOfSaleMessage={pointOfSaleMessage}
    />
  );
};

export default BookingPayeeSection;
